import {beanMapper} from "./bean-helpers";

export class BaseEntity {
    constructor(entity?: any) {
        if (entity) {
            beanMapper(entity, this);
        }
    }
}